module.exports = __webpack_public_path__ + "img/environment2.8366ab01.png";